import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import AuthHelperMethods from "./AuthHelperMethods";
import { TableHeader2, ModalWarning, ButtonOrange } from "./formComponents";
import SearchFilterDates from "./searchFilterDates";
import { dateISOtoStringShort } from "./momentUtils";
import { MyContext, ListContext } from "./MyContext";
import COLORS from "./styleConstants";
import { CSVLink } from "react-csv";
import { dateObjToDisplayDate } from "./momentUtils";
import SelectAccountHolder from "./selectAccountHolder";
import { SelectTemplateFilter } from "./searchFilterReports";

import Auth from "./Auth";

//****************************************************///
export const AdminPaymentReport = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);
  const [showItemDetailReport, setShowItemDetailReport] = useState(false);
  const [showMain, setShowMain] = useState(true);
  const [sortBy, setSortBy] = useState();
  const [direction, setDirection] = useState(true);
  const [purchaseList, setPurchaseList] = useState([]);
  const [packageDetails, setPackageDetails] = useState([]);
  const [currentPackage, setCurrentPackage] = useState();
  const [showWarning, setShowWarning] = useState(false);
  const [paymentToDelete, setPaymentToDelete] = useState();
  const [allPackageDetails, setAllPackageDetails] = useState([]);
  const [showAllDetails, setShowAllDetails] = useState(false);
  const [totals, setTotals] = useState(undefined);
  const [outstanding, setOutstanding] = useState(undefined);
  const location = useLocation();
  const [refreshPage, setRefreshPage] = useState(false);
  const [items, setItems] = useState([]);
  const [itemsTotal, setItemsTotal] = useState();

  const onInvoicePage = location.pathname?.endsWith("invoices");
  const onPaymentsPage = location?.pathname?.endsWith("paymentReport");

  useEffect(
    () => {
      //  return () => {

      dispatch2(["RESET_SEARCH_FILTER_EXCEPT_DATES"]);
      //  };
    },
    //eslint-disable-next-line
    [location],
  );

  useEffect(() => {
    if (listState.currentClient?.billing_person_id)
      dispatch2([
        "SET_SEARCH_FILTER",
        [listState.currentClient?.billing_person_id],
        "billing_person_id",
      ]);
  }, [listState.currentClient?.billing_person_id]);

  const ORANGEBUTTON = {
    backgroundColor: COLORS.orange,
    padding: 8,
    color: "white",
    fontSize: 12,
    minWidth: 100,
    margin: 5,
    borderRadius: 5,
    border: "medium none,",
    borderColor: COLORS.orange,
  };
  const dateText = `${
    listState.filter.date1 && dateObjToDisplayDate(listState.filter.date1)
  } to ${listState.filter.date2 && dateObjToDisplayDate(listState.filter.date2)}
`;
  const Csv = ({ data, filename }) => {
    return (
      <button style={ORANGEBUTTON}>
        <CSVLink
          data={data}
          filename={`${filename}.csv`}
          style={{ color: "white", width: "100%", display: "block" }}
        >
          Download CSV
        </CSVLink>
      </button>
    );
  };

  useEffect(
    () => {
      return () => {
        dispatch2(["RESET_SEARCH_FILTER_EXCEPT_DATES"]);
      };
    },
    //eslint-disable-next-line
    [],
  );
  //! main payment report
  useEffect(
    () => {
      let params = {
        ...listState.filter,
        report: "payment",
      };

      params.sortBy = sortBy;
      params.direction = direction ? "desc" : "asc";
      if (onInvoicePage) {
        params.include_invoices = true;
        params.sortBy = sortBy || "payments.paid";
        params.direction = direction ? "desc" : "asc";
      }

      if (onPaymentsPage) params.payments_only = true;

      const fetchData = async () => {
        dispatch({ type: "FETCH_INIT" });

        try {
          const result = await Auth.api("reports/financial", "get", params);

          result && setPurchaseList(result.data.reports);
          result && setTotals(result.data.totals.total);
          result &&
            result.data.outstandingTotals &&
            setOutstanding(result.data.outstandingTotals.outstanding);

          dispatch({ type: "FETCH_SUCCESS" });
        } catch {
          dispatch({ type: "FETCH_ERROR" });
        }
      };
      //    fetchData();
      if (listState.filter.date1 || (listState.filter.date2 && showMain))
        fetchData();
    },
    //eslint-disable-next-line
    [listState.filter, sortBy, location, direction, refreshPage],
  );
  //! extend payment report to show detail
  useEffect(
    () => {
      const fetchData = async () => {
        dispatch({ type: "FETCH_INIT" });
        let params = { ...listState.filter };
        try {
          const result = await Auth.api(
            "items/getAllItemsForPayment",
            "get",
            params,
          );
          result && setAllPackageDetails(result.data.items);

          dispatch({ type: "FETCH_SUCCESS" });
        } catch {
          dispatch({ type: "FETCH_ERROR" });
        }
      };
      if (showAllDetails) fetchData();
    },
    //eslint-disable-next-line
    [showAllDetails, refreshPage],
  );

  //! ItemDetail - by product
  useEffect(
    () => {
      const fetchData = async () => {
        dispatch({ type: "FETCH_INIT" });
        let params = { ...listState.filter };
        params.sortBy = sortBy;
        params.direction = direction ? "desc" : "asc";
        if (onPaymentsPage) params.payments_only = true;

        try {
          const result = await Auth.api(
            "items/getItemDetailReport",
            "get",
            params,
          );
          result && setItems(result.data.items);
          result && setItemsTotal(result.data.total);

          dispatch({ type: "FETCH_SUCCESS" });
        } catch {
          dispatch({ type: "FETCH_ERROR" });
        }
      };
      if (listState.filter.date1 || listState.filter.date2) fetchData();
    },
    //eslint-disable-next-line
    [
      listState.filter,
      sortBy,
      location,
      direction,
      refreshPage,
      showItemDetailReport,
    ],
  );

  const clickExportQuickbooks = async () => {
    try {
      dispatch({ type: "FETCH_INIT" });

      // Build params with the current filter dates
      let params = {};
      if (listState.filter.date1) {
        params.start_date = listState.filter.date1;
      }
      if (listState.filter.date2) {
        params.end_date = listState.filter.date2;
      }

      console.log("Exporting QuickBooks file with params:", params);

      const result = await Auth.api(
        "payments/export_invoices_iif",
        "get",
        params,
      );

      // Handle the blob response
      if (result && result.data) {
        const blob = new Blob([result.data], {
          type: "application/octet-stream",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "invoices.iif";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        dispatch({ type: "FETCH_SUCCESS" });
        console.log("QuickBooks export completed successfully");
      } else {
        throw new Error("No data received from export");
      }
    } catch (error) {
      dispatch({ type: "FETCH_ERROR" });
      console.error("QuickBooks export failed:", error);
      // You might want to show an alert here
      // alert.show("Export failed. Please try again.", { timeout: 3000, type: "error" });
    }
  };

  const clickExportPDF = async () => {
    try {
      dispatch({ type: "FETCH_INIT" });

      console.log("Generating PDF report...");

      // Create new PDF document
      const pdf = new jsPDF();

      // Add title
      pdf.setFontSize(20);
      pdf.text(`${onInvoicePage ? "Invoices" : "Payments"} Report`, 20, 20);

      // Add date range
      pdf.setFontSize(12);
      const dateRange = `Period: ${dateText}`;
      pdf.text(dateRange, 20, 35);

      // Prepare table data
      const tableData = purchaseList
        .map((item) => [
          item.amount || "",
          dateISOtoStringShort(item.received) || "",
          item.account || "",
          item.bank || "",
          item.reference || "",
          onInvoicePage ? (item.paid ? "paid" : "not paid") : "",
        ])
        .filter((row) => row.some((cell) => cell !== "")); // Remove empty rows

      // Table headers
      const headers = ["Amount", "Date", "Account", "Method", "Reference"];
      if (onInvoicePage) {
        headers.push("Status");
      }

      // Generate table
      autoTable(pdf, {
        head: [headers],
        body: tableData,
        startY: 50,
        styles: {
          fontSize: 10,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [255, 121, 0], // Orange color matching your theme
          textColor: [255, 255, 255],
          fontSize: 11,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        margin: { top: 50, left: 20, right: 20 },
        tableWidth: "auto",
        columnStyles: {
          0: { halign: "right" }, // Amount column right-aligned
          1: { halign: "center" }, // Date column centered
        },
      });

      // Add totals section
      let finalY = pdf.lastAutoTable.finalY + 10;

      if (totals) {
        pdf.setFontSize(12);
        pdf.setFont(undefined, "bold");
        pdf.text(`TOTAL: ${totals}`, 20, finalY);
        finalY += 10;
      }

      if (outstanding) {
        pdf.setTextColor(255, 0, 0); // Red color for outstanding
        pdf.text(`OUTSTANDING: ${outstanding}`, 20, finalY);
        pdf.setTextColor(0, 0, 0); // Reset to black
        finalY += 10;
      }

      // Add footer
      pdf.setFontSize(8);
      pdf.setFont(undefined, "normal");
      const pageCount = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.text(
          `Generated on ${new Date().toLocaleDateString()} - Page ${i} of ${pageCount}`,
          20,
          pdf.internal.pageSize.height - 10,
        );
      }

      // Save the PDF
      const filename = `${onInvoicePage ? "invoices" : "payments"}_report_${dateText.replace(/\s+/g, "_")}.pdf`;
      pdf.save(filename);

      dispatch({ type: "FETCH_SUCCESS" });
      console.log("PDF export completed successfully");
    } catch (error) {
      dispatch({ type: "FETCH_ERROR" });
      console.error("PDF export failed:", error);
      // You might want to show an alert here
      // alert.show("PDF export failed. Please try again.", { timeout: 3000, type: "error" });
    }
  };

  const handleGetDetail = async (paymentid) => {
    setCurrentPackage(paymentid);
    let params = { payment_id: paymentid };
    const result = await Auth.api("items/getItemsForPayment", "get", params);
    setPackageDetails(result.data.items);
  };

  const prepareDeletePayment = (itemId) => {
    setShowWarning(true);
    setPaymentToDelete(itemId);
  };
  const deletePayment = async () => {
    let params = { payment_id: paymentToDelete };
    try {
      const result = await Auth.api(
        "payments/deleteManualPayment",
        "post",
        params,
      );
      setPurchaseList(
        purchaseList.filter((purchase) => purchase.id !== paymentToDelete),
      );
      setShowWarning(false);
      setPaymentToDelete();
      setRefreshPage(!refreshPage);
    } catch {}
  };

  const changeSort = (sortIn) => {
    setSortBy(sortIn);
    setDirection(!direction);
  };

  function filterInvoices() {
    setPurchaseList(
      purchaseList.filter((purchase) => purchase.is_invoice === true),
    );
  }

  function handleShowLineItemDetailReport() {
    setShowMain(!showMain);
    setShowItemDetailReport(!showItemDetailReport);
  }

  return (
    <div className="topDiv">
      {showWarning && (
        <ModalWarning
          title={"Whoa there!"}
          proceedlabel={`Yes I want to delete this payment and its packages`}
          cancellabel={`No, I do not wish to delete this payment`}
          warningMessage={`Warning!  Any packages covered by this payment will also be deleted.`}
          warning2={
            "Package counts will be automatically recalculated when deleted."
          }
          cancel={() => setShowWarning(false)}
          proceed={deletePayment}
        ></ModalWarning>
      )}
      <div style={{ display: "flex" }}>
        {" "}
        <SelectAccountHolder />{" "}
      </div>

      <div
        className={"dteea"}
        style={{ display: "flex", flex: "1 1 100%", flexDirection: "column" }}
      >
        <SearchFilterDates />
      </div>
      {!showMain && (
        <SelectTemplateFilter
          options={mystate.options_product}
          isMulti
          label={"product"}
          list={listState.filter_labels.product || null}
          value={listState.filter.product || null}
          maxWidth={200}
        />
      )}

      {1 == 2 && (
        <ButtonOrange
          label={"Invoice Payments Only"}
          onClick={() => filterInvoices()}
        />
      )}
      {showMain && !onInvoicePage && (
        <ButtonOrange
          label={
            showAllDetails ? "Hide Payment Details" : "Show Payment Details"
          }
          onClick={() => setShowAllDetails(!showAllDetails)}
        />
      )}
      {onInvoicePage && (
        <ButtonOrange
          label={
            showAllDetails ? "Hide Invoice Details" : "Show Invoice Details"
          }
          onClick={() => setShowAllDetails(!showAllDetails)}
        />
      )}
      {!onInvoicePage && (
        <ButtonOrange
          label={showMain ? "View Line Items Only" : "View Payment Report"}
          onClick={() => handleShowLineItemDetailReport()}
        />
      )}
      <div
        className={"instructions"}
        style={{
          display: "flex",
          flex: "1 1 100%",
          flexDirection: "column",
          color: COLORS.orange,
          fontSize: 14,
        }}
      >
        {showItemDetailReport && (
          <div>
            This report lists items paid during the selected period, including
            items from invoices paid during that period. Unpaid invoice items
            are excluded.
          </div>
        )}
        <div>
          {" "}
          Payments and Invoices are grouped by account as items for mulitiple
          students on one account may occur as one transaction.
        </div>
        <div>
          {" "}
          You can search for the account by the account holder name or by the
          student name.
        </div>
      </div>
      <TableHeader2
        title={`${onInvoicePage ? "Invoice" : showItemDetailReport ? "Line Items" : "Payment"} Report`}
      />
      {showMain && (
        <div
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <Csv data={purchaseList || []} filename={`payments ${dateText}`} />

          <div
            className={"headerrow"}
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              color: COLORS.blue,
              fontWeight: "bold",
              padding: 7,
              textAlign: "left",
            }}
          >
            <div style={{ width: "10%" }} onClick={() => changeSort("amount")}>
              amount
            </div>
            <div
              style={{ width: "10%" }}
              onClick={() => changeSort("payments.created_at")}
            >
              date
            </div>
            <div
              style={{ width: "25%" }}
              onClick={() => changeSort("person_name")}
            >
              account
            </div>

            <div style={{ width: "10%" }}>method</div>

            <div style={{ width: "30%" }}>reference</div>
          </div>
          <div className="purchaseListBody">
            {purchaseList &&
              purchaseList.map((item) => (
                <>
                  <div
                    key={item.id}
                    className={"rowMain"}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      padding: 7,
                      fontSize: 14,
                      borderBottom: "solid 1pt lightgrey",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flex: "1 1 100%",
                        flexWrap: "wrap",
                        color: item.paid ? "grey" : "red",
                      }}
                    >
                      <div style={{ width: "10%" }}>{item.amount}</div>
                      <div style={{ width: "10%" }}>
                        {dateISOtoStringShort(item.received)}
                      </div>
                      <div style={{ width: "25%" }}>{item.account}</div>
                      <div style={{ width: "10%" }}>{item.bank}</div>
                      <div style={{ width: "35%" }}>{item.reference}</div>
                      {onInvoicePage && (
                        <div style={{ width: "10%" }}>
                          {item.paid ? "paid" : "not paid"}
                        </div>
                      )}

                      <div
                        className="deletePayment"
                        onClick={() => prepareDeletePayment(item.id)}
                        style={{
                          color: COLORS.orange,
                          cursor: "pointer",
                          width: "5%",
                        }}
                        style={{
                          color: COLORS.orange,
                          cursor: "pointer",
                          justifyContent: "end",
                        }}
                      >
                        {"delete"}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: "1 1 100%",
                        flexWrap: "wrap",
                      }}
                    >
                      {item.notes && (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            flex: "1 1 100%",
                            fontStyle: "italic",
                            color: "#737373",
                            paddingTop: 5,
                          }}
                        >
                          {item.notes}
                        </div>
                      )}
                    </div>
                  </div>

                  {showAllDetails &&
                    allPackageDetails &&
                    allPackageDetails.filter(
                      (piece) => piece.payment_id == item.id,
                    ).length > 0 && (
                      <div
                        className="packageDiv"
                        style={{
                          margin: 5,
                          border: `solid 2pt ${COLORS.lightgrey}`,
                          padding: 5,
                          display: "flex",
                          flex: "1 1 100%",
                          flexWrap: "wrap",
                          marginLeft: 100,
                          marginBottom: 30,
                          background: `${COLORS.lightgrey}`,
                        }}
                      >
                        <>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              flexDirection: "row",
                              flex: "1 1 100%",
                              color: COLORS.blue,
                              fontWeight: "bold",
                            }}
                          >
                            <div style={{ width: 200 }}>{"student"}</div>
                            <div style={{ width: 200 }}>{"package"}</div>
                            <div style={{ width: 100 }}>{"amount"}</div>
                            <div style={{ width: 100 }}>{"starts"}</div>
                            <div style={{ width: 100 }}>{"expires"}</div>
                          </div>
                          {allPackageDetails
                            .filter((piece) => piece.payment_id == item.id)
                            .map((row) => (
                              <div
                                className="packageRow"
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  flexDirection: "row",
                                  flex: "1 1 100%",
                                }}
                              >
                                <div style={{ width: 200 }}>
                                  {row.person_name}
                                </div>
                                <div style={{ width: 200 }}>
                                  {row.product_name}
                                </div>
                                <div style={{ width: 100 }}>
                                  {Number(row.price).toFixed(2)}
                                </div>
                                <div style={{ width: 100 }}>
                                  {dateISOtoStringShort(row.package_start_date)}
                                </div>
                                <div style={{ width: 100 }}>
                                  {dateISOtoStringShort(
                                    row.package_expiry_date,
                                  )}
                                </div>
                              </div>
                            ))}
                        </>
                      </div>
                    )}
                </>
              ))}
          </div>
          {totals && (
            <div className="purchaseListTotals">
              <span>TOTAL:</span>
              <span style={{ marginLeft: 10 }}>{totals}</span>
            </div>
          )}
          {onInvoicePage && outstanding && (
            <div className="purchaseListOutstanding" style={{ color: "red" }}>
              <span>OUTSTANDING:</span>
              <span style={{ marginLeft: 10 }}>{outstanding}</span>
            </div>
          )}
        </div>
      )}
      {showItemDetailReport && (
        <div className="itemdetailreport">
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            {Array.isArray(items) && items.length > 0 && (
              <Csv
                data={Array.isArray(items) ? items : []}
                filename={`item report ${dateText}`}
              />
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              flex: "1 1 100%",
              color: COLORS.blue,
              fontWeight: "bold",
            }}
          >
            <div
              style={{ width: 200 }}
              onClick={() => changeSort("products.product_name")}
            >
              {"product"}
            </div>
            <div style={{ width: 200 }} onClick={() => changeSort("price")}>
              {"amount"}
            </div>
            <div
              style={{ width: 200 }}
              onClick={() => changeSort("account_people.person_name")}
            >
              {"account"}
            </div>

            <div
              style={{ width: 100 }}
              onClick={() => changeSort("payments.date_received")}
            >
              {"purchase date"}
            </div>
          </div>
          {Array.isArray(items) &&
            items.map((row) => (
              <div
                className="packageRow"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  padding: 7,
                  fontSize: 14,
                  borderBottom: "solid 1pt lightgrey",
                  alignItems: "center",
                }}
              >
                <div style={{ width: 200 }}>{row.product_name}</div>
                <div style={{ width: 200 }}>{Number(row.price).toFixed(2)}</div>
                <div style={{ width: 200 }}>{row.account_name}</div>
                <div style={{ width: 100 }}>
                  {dateISOtoStringShort(row.date_received)}
                </div>
              </div>
            ))}
          {totals && (
            <div className="purchaseListTotals">
              <span>TOTAL:</span>
              <span style={{ marginLeft: 10 }}>{itemsTotal}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
